import React, { useEffect, useState } from "react";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import { LinearGradient } from "expo-linear-gradient";
import { Dimensions, Image, ScrollView, Text, TouchableOpacity, View, Switch, TextInput, ActivityIndicator } from "react-native";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../components/Tabs/react-tabs.css';
import { LineChart } from "react-native-chart-kit";
import DropDownPicker from "react-native-dropdown-picker";
import NumberInput from "../../components/NumberInput"
import ScreenLoader from '../../components/ScreenLoader'
import HeaderTabs from "../../components/HeaderTabs";
import balanceService from "../../services/balanceService";
import exchangeService from "../../services/exchangeService";
import styles from "./styles";
import { formatGPXBalance, maxDecimals } from '../../utils/formatNumber';
import activesService from '../../services/activesService';
import TradeView from "../../components/TradeView";
import axios from "axios";

export default function Token(props) {
  const navigation = useNavigation();
  const [token, setToken] = useState({});
  const [pageTab, setPageTab] = useState(0);
  const [heightPagerView, setHeightPagerView] = useState(350);
  const data = [30, 50, 40, 50, 40, 60];
  const screenWidth = Dimensions.get("window").width;
  const [valueIn, setValueIn] = useState(null);
  const [openIn, setOpenIn] = useState(false);
  const [balance, setBalance] = useState(0);
  const [items, setItems] = useState([
    {
      label: '1min',
      value: 1
    },
    // {
    //   label: '1S',
    //   value: 2
    // },
    // {
    //   label: '1M',
    //   value: 3
    // },
    // {
    //   label: '3M',
    //   value: 4
    // },
    // {
    //   label: '6M',
    //   value: 5
    // },
    // {
    //   label: '1A',
    //   value: 6
    // }
  ]);
  const [dateGraphic, setDateGraphic] = useState([
    '1'
  ]);
  const [dataGraphic, setDataGraphic] = useState([1]);

  const [lastQuote, setLastQuote] = useState('0.00');
  const [biggerQuote, setBiggerQuote] = useState('0.00');
  const [smallerQuote, setSmallerQuote] = useState('0.00');
  const [moviments, setMoviments] = useState([]);
  const [orders, setOrders] = useState([]);
  const [volume, setVolume] = useState(0);
  const [qtd, setQtd] = useState(0);
  const [switchOrder, setSwitchOrder] = useState(false);

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const contentInset = { top: 20, bottom: 20 };

  const [toFixed, setToFixed] = useState(0);

  const [amountToken, setAmountToken] = useState(0);

  const months = [
    'jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'
  ];
  DropDownPicker.addTranslation("PT", {
    PLACEHOLDER: "Selecione...",
    NOTHING_TO_SHOW: "Nada para mostrar!"
  });
  DropDownPicker.setLanguage("PT");
  useEffect(() => {
    setToken({ id: props.route.params.id, name_token: props.route.params.name_token, path: props.route.params.path, single_value: props.route.params.single_value, cryptoactive: props.route.params.cryptoactive });
  }, []);
  useEffect(() => {
    if (token.id) {
      getExchangeDetails();
      getExchangeOrders();
      getBalance();
      AsyncStorage.setItem("id_coin", JSON.stringify(token.id));


      if(token?.name_token) {
        if(['BTC', 'ETH', 'ADA'].indexOf(token?.name_token) !== -1) {
          setToFixed(8);
        }else{
          setToFixed(0);
        }
        if(!token.cryptoactive) {
          loadAmountToken();
        }else{
          setAmountToken(0);
        }  
      }
    }
  }, [token]);

  const [seconds, setSeconds] = useState(0);
  const [quotes, setQuotes] = useState([]);
  const [authorizationToken, setAuthorizationToken] = useState('');

  const [binancePrice, setBinancePrice] = useState();
  const [binanceOrderBookBid, setBinanceOrderBookBid] = useState();
  const [binanceOrderBookAsk, setBinanceOrderBookAsk] = useState();
  const [binanceTrades, setBinanceTrades] = useState();

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(seconds => seconds + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    loadAuthorization();
  }, []);

  useEffect(() => {
    if(authorizationToken && token?.id) {
      console.log(token);
      if(token?.name_token && ['BTC', 'ETH', 'ADA'].indexOf(token?.name_token) !== -1) {
        //console.log('BTC', 'ETH', 'ADA');
        let pair = token?.name_token+'BRL';

        // orderBook
        axios.get('https://api.binance.com/api/v3/depth?symbol='+pair+'&limit=50').then((response) => {
          if(response?.data?.bids) {
            setBinanceOrderBookBid(response?.data?.bids);
          }
          if(response?.data?.asks) {
            setBinanceOrderBookAsk(response?.data?.asks);
          }
        }).catch((error) => {
        });

        // trades
        axios.get('https://api.binance.com/api/v3/trades?symbol='+pair+'&limit=50').then((response) => {
          if(response?.data?.length > 0) {
            setBinanceTrades(response.data);
            setQuotes(response.data.slice(0, 10));
          }
        });

        // price
        axios.get('https://api.binance.com/api/v3/ticker/price?symbol='+pair).then((response) => {
          if(response?.data?.price) {
            setLastQuote(parseFloat(response.data.price)*1.015);
          }
        });

        getBinanceCandlestickData(pair);
      }else{
        activesService.getLastQuotesByActiveId(authorizationToken, token.id).then((response) => {
          if(response.status === 200) {
            if(response.data.length > 0) {
              setLastQuote(parseFloat(response.data[0].price));
              setQuotes(response.data);
              console.log(response.data);
            }
          }
        });
        getExchangeDetails();
        getExchangeOrders();
      }        
      setLoading1(false);

    }
  }, [seconds, authorizationToken, token]);

  useEffect(() => {
    if (quotes) {
      let newDateGraphic = [];
      let newDataGraphic = [];
      //let currentDate = new Date();
      for (let i = 0; i < Math.min(quotes.length, 6); i++) {
        if(token?.name_token && ['BTC', 'ETH', 'ADA'].indexOf(token?.name_token) !== -1) {
          let d = new Date(quotes[i].time);
          newDateGraphic.push(('0'+d.getHours()).slice(-2)+':'+('0'+d.getMinutes()).slice(-2)+':'+('0'+d.getSeconds()).slice(-2));
          newDataGraphic.push(parseFloat(quotes[i].price+''));
        }else{
          newDateGraphic.unshift(quotes[i].label);
          newDataGraphic.unshift(parseFloat(quotes[i].price+''));
        }
        
      }
      setDateGraphic(newDateGraphic);
      setDataGraphic(newDataGraphic);
    }
  }, [quotes]);
  
  useEffect(() => {
    if(binanceTrades && binanceTrades.length > 0) {
      let nMoviments = [];
      for(let i = 0; i < Math.min(binanceTrades.length, 6); i++) {
        nMoviments.push({
          quantity: binanceTrades[i].qty,
          value_coin: binanceTrades[i].price
        });
      }
      setMoviments(nMoviments);
    }
  }, [binanceTrades]);

  useEffect(() => {
    console.log(token);
  }, [token]);

  const loadAmountToken = async () => {
    let auth = '';
    if(authorizationToken) {
      auth = authorizationToken;
    }else{
      auth = await AsyncStorage.getItem('JWT_TOKEN');
    }
    activesService.getById(auth, token.id).then((response) => {
        if(response.data?.count) {
            setAmountToken(response.data?.count);
        }
    });
  }

  const loadAuthorization = async () => {
    const authtoken = await AsyncStorage.getItem('JWT_TOKEN');
    setAuthorizationToken(authtoken);
  }

  const getExchangeDetails = async () => {
    const authtoken = await AsyncStorage.getItem('JWT_TOKEN');
    //setLoading1(true)
    exchangeService.getDetailsByToken(authtoken, token.id).then((response) => {
      if (response.status === 200) {
        if (response.data.ultima?.value_coin)
          setLastQuote(response.data.ultima.value_coin);
        if (response.data.maior?.value_coin)
          setBiggerQuote(response.data.maior.value_coin);
        if (response.data.menor?.value_coin)
          setSmallerQuote(response.data.menor.value_coin);
        if (response.data.negociacoes)
          setMoviments(response.data.negociacoes);
        if (response.data.ordens)
          setOrders(response.data.ordens);
        if (response.data.volume['24h'])
          setVolume(response.data.volume['24h']);
      }
      setLoading1(false)
    }).catch((error) => {
      setLoading1(false)
      console.log(error);
    });
  }
  const getExchangeOrders = async () => {
    setOrders([]);
    //setLoading2(true)
    const authtoken = await AsyncStorage.getItem('JWT_TOKEN');
    exchangeService.getOrdersByActive(authtoken, token.id).then((response) => {
      setLoading2(false)
      setOrders(response.data);
    }).catch((error) => {
      setLoading2(false)
      console.log(error);
    });
  }

  const getBinanceExchangeOrders = async () => {
    setOrders([]);
    const authtoken = await AsyncStorage.getItem('JWT_TOKEN');
    exchangeService.getOrders(authtoken, token.id).then((response) => {
      setOrders(response.data);
    }).catch((error) => {
      console.log(error);
    });
  }
    
  const confirmCancelOrder = async (orderId) => {
    const authtoken = await AsyncStorage.getItem('JWT_TOKEN');
    if(token && token.cryptoactive) {
      exchangeService.cancelOrderBinance(authtoken, orderId).then((response) => {
        console.log('deleteOrderResponseBinance')
        console.log(response.status);
      }).catch((error) => {
          if (error.response?.data?.message) {
              toast(error.response?.data?.message, "#DA1414");
          }else{
            toast('Ocorreu um erro ao cancelar a sua ordem.', "#DA1414");
          }
      });
    }else{
      exchangeService.cancelOrder(authtoken, orderId).then((response) => {
        console.log('deleteOrderResponse')
        console.log(response.status)
        getExchangeOrders();
      }).catch((error) => {
        console.log(error);
      });
    }

  }

  const cancelOrder = async (orderId, valueCoin) => {
    console.log(orderId);
    const authtoken = await AsyncStorage.getItem('JWT_TOKEN');
    const value = formatGPXBalance(valueCoin)

    if (confirm(`Cancelamento de ordem\nTem certeza que deseja cancelar ordem no valor de ${value}?`)) {
      console.log(orderId);
      confirmCancelOrder(orderId);
    } else {
      return
    }
  }
  const getBalance = async () => {
    setLoading3(true)
    const authToken = await AsyncStorage.getItem('JWT_TOKEN');
    balanceService.getBalanceOfToken(authToken, token.id).then((response) => {
      setLoading3(false)
      setBalance(response?.data?.saldo + '');
    }).catch((error) => {
      setLoading3(false)
      console.log(error)
    });
  }

  function handleSelectedPage(page) {
    setPageTab(page);

    if (page === 0) {
      setHeightPagerView(350);
    }

    if (page === 1) {
      setHeightPagerView(220);
    }

    if (page === 2) {
      setHeightPagerView(220);
    }
  }

  function selectedTimeGraphic(value) {
    console.log(value);
  }

  const getTokenName = () => {
    if (token?.name_token) {
      return token?.name_token;
    }
    return '';
  }

  const getTokenValue = () => {
    if (lastQuote && parseFloat(lastQuote+'') > 0) {
      return parseFloat(lastQuote);
    }
    if (token?.single_value) {
      return parseFloat(token?.single_value);
    }
    return 0.00;
  }

  const getBinanceCandlestickData = (pair) => {

    axios.get('https://api.binance.com/api/v3/klines?symbol='+pair+'&interval=1d&limit=1').then((response) => {
      if(response?.data?.length > 0) {
        if (response.data[0][2])
          setBiggerQuote((parseFloat(response.data[0][2]) * 1.015) );
        if (response.data[0][3])
          setSmallerQuote( (parseFloat(response.data[0][3]) * 1.015) );
        if (response.data[0][5])
          setVolume(response.data[0][5] / 100);
      }
    });

  }

  const TokenHeader = () => (
    <View style={styles.token_header_container}>
      {token.path && <Image source={{ uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${token.path}` }} style={styles.token_header_image} />}
      <View style={{ marginLeft: 20 }}>
        <Text style={styles.token_header_title}>{token.name ? token.name : token.name_token}</Text>
        <View>
          <Text style={styles.token_header_info}>Valor atual</Text>
          <Text style={styles.token_header_value}>{formatGPXBalance(getTokenValue())} GPX</Text>
          <Text style={styles.balance_info_value}>R$ {formatGPXBalance(getTokenValue())}</Text>
        </View>
      </View>
    </View>
  );

  const TokenHeaderInfo = () => (
    <>
      <View style={styles.token_info_container}>
        <View style={styles.token_info}>
          <Text style={styles.token_info_title}>Variação</Text>
          <Text style={styles.token_percent_value}>{smallerQuote && formatGPXBalance(((parseFloat(getTokenValue()+'')-parseFloat(smallerQuote+''))/parseFloat(smallerQuote+''))*100)}%</Text>
        </View>

        <View style={styles.token_info}>
          <Text style={styles.token_info_title}>Última</Text>
          <Text style={styles.token_default_info_value}>{formatGPXBalance(getTokenValue())} GPX</Text>
        </View>
      </View>
      <View
        style={{
          marginTop: 20,
          paddingHorizontal: "10%",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <View style={{ alignItems: "center" }}>
          <Text style={styles.token_info_title}>Menor</Text>
          <Text style={styles.token_default_info_value}>{smallerQuote && formatGPXBalance(smallerQuote)} GPX</Text>
        </View>

        <View style={{ alignItems: "center" }}>
          <Text style={styles.token_info_title}>Maior</Text>
          <Text style={styles.token_default_info_value}>{biggerQuote && formatGPXBalance(biggerQuote)} GPX</Text>
        </View>

        <View style={{ alignItems: "center" }}>
          <Text style={styles.token_info_title}>Volume em 24h</Text>
          <Text style={styles.token_default_info_value}>{volume && formatGPXBalance(volume)} {getTokenName()} </Text>
        </View>
      </View>
      <View style={styles.hl} />
    </>
  );

  const BalanceInfo = () => (
    <View style={styles.balance_info_container}>
      <View>
        {
            (token && !token.cryptoactive) ?
            <>
            <Text style={styles.balance_info_title}>Quantidade disponível</Text>
            <Text style={styles.balance_info_value}>{amountToken} {getTokenName()}</Text>
            </>
            :
            <></>
        }
      </View>

      <View style={{ alignItems: "flex-end" }}>
        <Text style={styles.balance_info_title}>Meu saldo</Text>
        <Text style={styles.balance_info_value}>{(token && !token.cryptoactive) ? balance : maxDecimals(balance, 8)} {getTokenName()}</Text>
        <Text style={styles.balance_info_value}>{formatGPXBalance(balance * getTokenValue())} GPX</Text>
      </View>
    </View>
  );

  const handleBuy = () => {
    let objParam = { qtd: qtd, token: token.id, viewType: 'buy', customTokenValue: getTokenValue() };
    if (token && (['BTC', 'ETH', 'ADA'].indexOf(token.name) === -1) ) {
      objParam = { qtd: qtd, token: token.id, viewType: 'buy', market: true, customTokenValue: getTokenValue() };
    }
    navigation.navigate('ConfirmPurchaseOrSell', 
    //{ qtd: qtd, token: token.id, viewType: 'buy', market: true, customTokenValue: customTokenValue })}
    objParam);
  }

  const handleSell = () => {
    let objParam = { qtd: qtd, token: token.id, viewType: 'sell', customTokenValue: getTokenValue() };
    if (token && (['BTC', 'ETH', 'ADA'].indexOf(token.name) === -1) ) {
      objParam = { qtd: qtd, token: token.id, viewType: 'sell', market: true, customTokenValue: getTokenValue() };
    }
    navigation.navigate('ConfirmPurchaseOrSell',
    //{ qtd: qtd, token: token.id, viewType: 'sell', market: true, customTokenValue: customTokenValue })}
    objParam);
  }

  const [customTokenValue, setCustomTokenValue] = useState(0)
  
  const handleChangeValue = (value) => {
    setQtd(value)
  }
  const handleChangeCustomPrice = (value) => {
    const formattedNumber = value.replace(',', '.').replace(/^(\d*\.?)|(\d*)\.?/g, "$1$2")
    setCustomTokenValue(formattedNumber)
  }
  useEffect(() => {
    !switchOrder && setCustomTokenValue(0)
  }, [switchOrder])

  return (
    <View style={styles.container}>
      <ScreenLoader loading={loading1 || loading2 || loading3} />

      <HeaderTabs
        title={"EXCHANGE"}
        iconLeft={"keyboard-arrow-left"}
        routeLeft={"Exchange"}
        subtitle={"Negocie, venda e acompanhe os tokens do mercado"}
      />

      <TokenHeader />

      <TokenHeaderInfo />

      <Tabs>
        <TabList style={{ textAlign: "center" }}>
          <Tab>Gráficos</Tab>
          <Tab>Negociações</Tab>
          <Tab>Ordens</Tab>
        </TabList>
        <TabPanel>
          {
            token &&
            <TradeView idCoin={token?.id}/>
          }
        </TabPanel>
        <TabPanel>
          <View style={styles.contentPageTab}>
            <View style={styles.contentOrders}>
              <Text style={styles.ordersPurchase}>Negociações <Text style={styles.orderPurchasesBold}>realizadas</Text></Text>
            </View>
            <View style={styles.hr} />
            <View style={styles.contentDescriptionOrders}>
              <Text style={styles.textDescriptionsOrders}>Quantidade</Text>
              <Text style={styles.textDescriptionsOrders}>Preço</Text>
            </View>
            <View style={styles.contentPurchaseOrSale}>
              <View style={{ width: '100%' }}>
                {
                  moviments.map((el, index) =>
                    <View style={styles.contentPurchaseOrSale} key={index}>
                      <Text style={styles.amountPurchase}>{el.quantity}</Text>
                      <Text style={styles.pricePurchase}>{el.value_coin}</Text>
                    </View>
                  )
                }
              </View>
              

            </View>
          </View>
        </TabPanel>
        <TabPanel>
          <View style={styles.contentPageTab}>
            <View style={styles.contentOrders}>
              <Text style={styles.ordersPurchase}>Ordens de <Text style={styles.orderPurchasesBold}>compra</Text> e <Text style={styles.orderPurchasesBold}>venda</Text></Text>
            </View>
            <View style={styles.hr} />
            <View style={styles.contentDescriptionOrders}>

              <Text style={styles.textDescriptionsOrders}>Quantidade</Text>
              <Text style={styles.textDescriptionsOrders}>Preço</Text>

              <Text style={styles.actionsOrders}>Ações</Text>
            </View>
            <View style={styles.contentPurchaseOrSale}>
              <View style={{ width: '80%' }}>
                {orders.length > 0 ? orders.map((el, index) => {
                  if (el.is_purchase == true) {
                    return <View style={styles.contentPurchaseOrSale} key={index}>
                      <Text style={styles.amountPurchase}>{el.quantity}</Text>
                      <Text style={styles.pricePurchase}>{formatGPXBalance(el.value_coin)}</Text>
                      <TouchableOpacity onPress={() => cancelOrder(el.id, el.value_coin)}><Text style={styles.actionButton}>Cancelar compra</Text></TouchableOpacity>
                    </View>
                  } else {
                    return <View style={styles.contentPurchaseOrSale} key={index}>
                      <Text style={styles.amountSale}>{el.quantity}</Text>
                      <Text style={styles.priceSale}>{formatGPXBalance(el.value_coin)}</Text>
                      <TouchableOpacity onPress={() => cancelOrder(el.id, el.value_coin)}><Text style={styles.actionButton}>Cancelar venda</Text></TouchableOpacity>
                    </View>
                  }
                }
                ) :
                  <ActivityIndicator color="#1FBFB5" size="large" style={{ marginTop: 10 }} />
                }
              </View>
            </View>
          </View>
        </TabPanel>
      </Tabs >
      <ScrollView >
        {/* <PagerView
          style={{ height: heightPagerView, width: '100%', marginTop: 10 }}
          initialPage={pageTab}
          key={pageTab}
          scrollEnabled={false}
        > */}
        <BalanceInfo />
          {/* <ActionButtons qtd={qtd} setQtd={(qtdParam) => setQtd(qtdParam)} switchOrder={switchOrder} setSwitchOrder={(setParam) => setSwitchOrder(setParam)} handleBuy={() => {handleBuy()}} handleSell={() => {handleSell()}}/> */}
          <>
          {
            (token) ?
            <View style={[styles.switch]}>
              <Text style={[switchOrder ? styles.textDisabled : styles.textEnabled]}>
                Ordem rápida
              </Text>
              <Switch
                trackColor={"#ccc"}
                thumbColor={"#1FBFB5"}
                ios_backgroundColor="#3e3e3e"
                onValueChange={setSwitchOrder}
                value={switchOrder}
                style={{ marginHorizontal: 20 }}
              />
              <Text style={[switchOrder ? styles.textEnabled : styles.textDisabled]}>
                Ordem limitada
              </Text>
            </View>
            : 
            <>
            </>
          }
          {switchOrder && <><View style={styles.action_buttons_container}>
            <Text>Preço</Text>
            <TextInput
              value={`${customTokenValue}`}
              keyboardType="numeric"
              style={styles.priceInput}
              onChangeText={(text) => handleChangeCustomPrice(text)}
            />
            <Text style={{ fontWeight: "bold" }}>GPX/BRL</Text>
          </View>
            {/* <Text style={{ fontSize: 12, textAlign: "center" }}>Usar saldo disponível: {formatGPXBalance(balance)}</Text>
            <View style={styles.percentageButtonsContainer}>
              <TouchableOpacity style={styles.percentageButton}>
                <Text style={styles.percentageButtonText}>25%</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.percentageButton}>
                <Text style={styles.percentageButtonText}>50%</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.percentageButton}>
                <Text style={styles.percentageButtonText}>75%</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.percentageButton}>
                <Text style={styles.percentageButtonText}>100%</Text>
              </TouchableOpacity>
            </View>  */}
          </>
          }

          <View style={styles.contentPurchase}>
            <Text style={styles.titlePurchase}>Quanto deseja?</Text>
            <View style={styles.contentPurchaseAmount}>
              <NumberInput
                value={qtd}
                maxDecimalsParam={toFixed}
                onChange={value => handleChangeValue(value)}
              />
            </View>
            <View style={{ alignItems: 'center' }}>
              <Text style={{ color: '#656565', paddingTop: 5 }}>{formatGPXBalance((qtd * getTokenValue()))} GPX/BRL</Text>
            </View>
          </View>
          {
                  parseFloat(qtd * getTokenValue()) < 11 ?
                  <>
                  <View style={{ alignItems: 'center' }}>
                    <Text style={{ color: 'red', paddingTop: 5, paddingBottom: 5 }}>Mínimo de 11 GPX/BRL</Text>
                  </View>
                  </>
                  :
                  <>
                  <View style={styles.action_buttons_container}>
                    <TouchableOpacity disabled={qtd > 0 ? false : true} style={{ width: "45%" }} onPress={() => {handleBuy()}}>
                      <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#00490C", "#32BFB1"]}
                        style={styles.action_button}
                      >
                        <Text style={styles.action_button_text}>Comprar</Text>
                      </LinearGradient>
                    </TouchableOpacity>
                    {balance > 0 && balance >= qtd ?
                      <TouchableOpacity
                        style={{ width: "45%" }}
                        onPress={() => {handleSell()}}>
                        <LinearGradient
                          start={{ x: -1, y: 0 }}
                          end={{ x: 1, y: 0 }}
                          colors={["#AA0000", "#FF5454"]}
                          style={styles.action_button}
                        >
                          <Text style={styles.action_button_text}>Vender</Text>
                        </LinearGradient>
                      </TouchableOpacity>
                      :
                      <TouchableOpacity style={{ width: "45%" }}>
                        <LinearGradient
                          start={{ x: -1, y: 0 }}
                          end={{ x: 1, y: 0 }}
                          colors={["#AA0000", "#FF5454"]}
                          style={styles.action_button}
                        >
                          <Text style={styles.action_button_text}>Sem Saldo</Text>
                        </LinearGradient>
                      </TouchableOpacity>
                    }
                  </View>
                  </>
          }        
        </>
      </ScrollView>
    </View >
  );
}
